import React, { ReactNode, useState } from 'react';
import ShowIcon from '@assets/icons/show icon.svg';
import { SvgIcon } from '@components-library/Icons/SvgIcon';
import cn from 'classnames';

interface IInputProps {
  name: string;
  label: string;
  value: string | null;
  required: boolean;
  pattern?: string;
  errorMessage?: string;
  disabled?: boolean;
  canToggleMask?: boolean;
  maskable?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>, map?: Record<string, string>) => void;
  hint?: ReactNode;
  cssClass: string;
}

export const Input = ({
  name,
  label,
  value,
  required,
  pattern,
  errorMessage,
  disabled = false,
  maskable = false,
  canToggleMask,
  onChange,
  hint,
  cssClass,
}: IInputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const inputType = maskable && !showPassword ? 'password' : 'text';

  return (
    <label className={`cc-field ${cssClass} ${inputType}`}>
      <span className="cc-filed__label">
        {label}
        {required && <span className="cc-filed__required">*</span>}
        {hint && <span className="cc-filed__hint">{hint}</span>}
      </span>
      <input
        className="cc-input"
        type={inputType}
        name={name}
        value={value === null ? '' : value}
        onChange={(e) =>
          onChange(e, {
            patternMismatch: errorMessage || '',
          })
        }
        required={required}
        pattern={pattern}
        disabled={disabled}
      />
      {canToggleMask && maskable && (
        <button
          type="button"
          tabIndex={1000}
          className={cn('form__showpassword', { hide: showPassword })}
          onClick={() => setShowPassword(!showPassword)}>
          <SvgIcon src={ShowIcon} className="form__showpassword-icon" />
        </button>
      )}
    </label>
  );
};
